import { StringWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';
import { ModalController, NavController } from 'ionic-angular';

@Component({
    selector: 'app-sf-filter-widget',
    templateUrl: './filter.widget.html'
})
export class MyFilterWidgetComponent extends StringWidget {

    constructor(
        public modalCtrl: ModalController,
        public navCtrl: NavController
    ) {
        super();
    }

    /**
     * Filter
     */
    showFilter(schema, control) {
        schema.datasource.control = control;
        this.navCtrl.push("AppBuilderSearchPage", schema.datasource);
    }


}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/filter/filter.widget.ts